import { tokenState } from "../auth/tokenState";
import { usePersister } from "../utils/persister";
import { isGuest as checkIsGuest } from "../auth/authFunctions";
import { createContext, PropsWithChildren, useContext } from "react";

interface AuthContextValue {
  isLoggedIn: boolean;
  isGuest: boolean;
}

const AuthContext = createContext<AuthContextValue>({
  isLoggedIn: false,
  isGuest: false,
});

export function useAuthContext() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }: PropsWithChildren<{}>) {
  const [refreshToken] = usePersister(tokenState.refreshToken);
  const isLoggedIn = !!refreshToken;
  const isGuest = checkIsGuest();

  return (
    <AuthContext.Provider value={{ isLoggedIn, isGuest }}>
      {children}
    </AuthContext.Provider>
  );
}
